

import React from 'react';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import RequestProvider from '../../RequestProvider';
import { getContractsQuery } from '../../../common/api';
import SubscriptionInfoV2Component from '../components/SubscriptionInfoV2';







function SubscriptionInfoV2() {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } = {} }) =>
      <RequestProvider
        requests={{
          getContracts: getContractsQuery()
        }}>

          {(requests) =>
        <SizeMe>
              {({ size: { width } = { width: 0 } }) =>
          <SubscriptionInfoV2Component
            width={width}
            organisationId={organisationId}
            {...requests} />}


            </SizeMe>}

        </RequestProvider>}

    </AuthorisationConsumer>);

}

export default withRouter(SubscriptionInfoV2);